import { MessageSquare, Search, ClipboardCheck, Ship } from "lucide-react";
import SectionHeader from "./SectionHeader";

const STEPS = [
    {
        icon: MessageSquare,
        title: "Connect",
        desc: "Share your sourcing needs or supply capabilities. We respond within one business day with a tailored brief."
    },
    {
        icon: Search,
        title: "Source & Match",
        desc: "We identify the right brand, supplier or buyer for your brief and present clear, comparable options with full source documentation."
    },
    {
        icon: ClipboardCheck,
        title: "Verify & Contract",
        desc: "Compliance checks, sample approvals and clean documentation — terms agreed transparently on both sides."
    },
    {
        icon: Ship,
        title: "Ship & Deliver",
        desc: "We coordinate freight, customs and final-mile so goods arrive on time, in spec, with full traceability."
    }
];

export default function Process() {
    return (
        <section id="process" className="py-20 lg:py-28">
            <div className="container-px mx-auto max-w-7xl">
                <SectionHeader
                    eyebrow="How we work"
                    title="A simple, transparent process from first call to final delivery."
                    description="No black boxes. Every engagement follows the same four-step framework so partners always know where their shipment stands."
                />

                <div className="mt-14 relative">
                    {/* connecting line on desktop */}
                    <div className="hidden lg:block absolute top-[34px] left-[5%] right-[5%] h-px bg-border" />
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                        {STEPS.map((s, idx) => (
                            <div key={s.title} className="flex flex-col">
                                <div className="relative">
                                    <span className="relative z-10 grid place-items-center w-16 h-16 rounded-xl bg-primary text-primary-foreground shadow-soft">
                                        <s.icon className="w-6 h-6" />
                                    </span>
                                    <span className="absolute -top-2 left-14 w-7 h-7 rounded-full bg-background border border-border grid place-items-center text-[11px] font-semibold text-primary">
                                        {String(idx + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="mt-6 font-display text-lg font-semibold text-foreground">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                                    {s.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
